import { post, get } from './api';

export default {
  sendSlackCrashReport: async function (data) {
    return await post('/public/crash_error_message', data);
  }
};
